const NATIVE_TOKEN = "0x0000000000000000000000000000000000000001";
const POLYGON_NATIVE_TOKEN = "0x0000000000000000000000000000000000001010";

export { NATIVE_TOKEN, POLYGON_NATIVE_TOKEN };
